import React from 'react';
import './PitchStoryPage.css';

// Replace with your actual flyer import
import pitchFlyer from '../Assets/storyfest/pitchyourstory.jpeg';

const PitchStoryPage = () => {
  return (
    <div className="pitch-story-page">
      
      {/* Background Texture */}
      <div className="pitch-bg-pattern"></div>

      <div className="pitch-container">
        
        {/* =========================================
            TOP SECTION: Hero & Flyer
            ========================================= */}
        <div className="pitch-hero-grid">
          
          {/* Left Text */}
          <div className="pitch-hero-text">
            <div className="pitch-badge">
              <span className="pitch-pulse-dot"></span>
              A StoryFest Talent Competition
            </div>

            <h1 className="pitch-title">
              Pitch<br />
              <span className="pitch-text-gold">Your Story.</span>
            </h1>
            
            <p className="pitch-subtitle">
              Have you dreamed of becoming an author and receiving mentorship to publish your own book? 
              This is your opportunity to show us what makes your story original, exceptional, and memorable.
            </p>
            
            <p className="pitch-desc">
              You are invited to submit a <strong>60-second video</strong> explaining why your story matters and showcasing your creativity.
            </p>

            {/* 👇 UPDATED: Opens in new tab */}
            <a 
              href="https://docs.google.com/forms/d/e/1FAIpQLSezff8g3ndkkd35BuKELBHsKB8W9WmytkbBnweDM04WimYz-A/viewform" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="pitch-btn-submit"
            >
              Submit Your 60-Second Video ↗
            </a>
          </div>

          {/* Right Flyer */}
          <div className="pitch-hero-flyer">
            <div className="pitch-flyer-wrapper">
              <img src={pitchFlyer} alt="Pitch Your Story Flyer" className="pitch-flyer-img" />
            </div>
          </div>

        </div>

        {/* =========================================
            WHAT YOU CAN DO (Talent Grid)
            ========================================= */}
        <div className="pitch-talents-section">
          <h2 className="pitch-section-title">Showcase Your Talent</h2>
          <p className="pitch-section-subtitle">
            Your entry may include any of the following (or something else entirely!):
          </p>
          
          <div className="pitch-talents-grid">
            {['Speech', 'Storytelling', 'Song', 'Dance', 'Poetry', 'Art', 'Photography', 'Writing', 'Filmmaking'].map((talent, i) => (
              <span key={i} className="pitch-talent-tag">{talent}</span>
            ))}
          </div>
        </div>

        {/* =========================================
            HOW IT WORKS (3 Steps)
            ========================================= */}
        <div className="pitch-steps-section">
          <h2 className="pitch-section-title">How It Works</h2>
          
          <div className="pitch-steps-grid">
            <div className="pitch-step">
              <span className="pitch-step-num">01</span>
              <h4>Create Your Video</h4>
              <p>Record a 60-second video pitching your story and showcasing your talent.</p>
            </div>
            <div className="pitch-step">
              <span className="pitch-step-num">02</span>
              <h4>Submit Online</h4>
              <p>Upload your video for review by our panel of judges.</p>
            </div>
            <div className="pitch-step">
              <span className="pitch-step-num">03</span>
              <h4>Pitch Live</h4>
              <p>Shortlisted applicants will make a 10-minute live presentation at StoryFest Ghana 2026.</p>
            </div>
          </div>
        </div>

        {/* =========================================
            PRIZES & DETAILS
            ========================================= */}
        <div className="pitch-prizes-section">
          <div className="pitch-prize-card">
            <h3>The Grand Prize</h3>
            <p>
              The top three awardees will receive full support to <strong>publish and market their books internationally.</strong>
            </p>
          </div>

          <div className="pitch-info-card">
            <h3>📍 The Finale</h3>
            <p>
              Live presentations will take place at <strong>StoryFest Ghana</strong>, 
              from <strong>11-13 December 2026</strong> at the <strong>Accra City Hotel</strong>.
            </p>
          </div>
        </div>

        {/* =========================================
            CONSENT & SUBMIT
            ========================================= */}
        <div className="pitch-consent-section" id="submit">
          <div className="pitch-consent-box">
            <h3>Important Note for Parents & Guardians</h3>
            <p>
              Parents or guardians of participants under the age of 18 must provide consent for entry. 
              Please ensure you have permission before submitting your video.
            </p>
          </div>
          
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSezff8g3ndkkd35BuKELBHsKB8W9WmytkbBnweDM04WimYz-A/viewform" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="pitch-btn-submit pitch-btn-large"
          >
            Submit Your Entry Now ↗
          </a>
        </div>

      </div>
    </div>
  );
};

export default PitchStoryPage;